import Vue from 'vue'

import withRender from './popover.html'
import './popover.scss'

const TYPES = ['success', 'error']

export default withRender(Vue.extend({
  props: {
    ariaLabel: String,
    asAlertDialog: Boolean,
    autoClose: Boolean,
    closeLabel: String,
    // specify message or provide slot
    message: String,
    showClose: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'success',
      validator: v => TYPES.indexOf(v) > -1
    }
  },
  computed: {
    iconName() {
      return this.type === 'error' ? 'error' : 'check'
    },
    typeClass() {
      return this.type ? `tt-o-popover--${this.type}` : ''
    },
    role() {
      return this.asAlertDialog ? 'alertdialog' : 'alert'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  },
  created() {
    if (this.asAlertDialog && !this.ariaLabel && process.env.NODE_ENV === 'development') {
      // tslint:disable:next-line no-console
      console.error('Must provide ariaLabel')
    }
  },
  mounted() {
    if (this.autoClose) {
      // will close after a period of time.  Must use a v-if on the popover for mounted to be
      // called each time it is shown.
      setTimeout(() => {
        this.close()
      }, (this.type === 'error' ? 10000 : 6000))
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/popover/popover.ts